/*
 * VatomInc. Copyright (c) 2022, all rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in the root directory of this source tree.
 */

import Moralis from 'moralis-v1/react-native'

import logger from '../../logger'
import { EventEmitter } from '../EventEmitter'

export default class WebSockets extends EventEmitter {
  dataPool: any
  moralis: Moralis

  constructor(moralis: Moralis) {
    super()
    this.moralis = moralis
  }

  loadWS(address: string) {
    this.startWS(address, 'Polygon', 'polygon')
    this.startWS(address, 'Eth', 'eth')
    this.startWS(address, 'Bsc', 'bsc')
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  close() {}

  async startWS(address: string, networkDescription: string, network: any) {
    const route = networkDescription + 'NFTTransfers'

    const receiving = new this.moralis.Query(route)
    receiving.equalTo('from_address', address)

    const sending = new this.moralis.Query(route)
    sending.equalTo('to_address', address)

    const query = this.moralis.Query.or(receiving, sending)
    const subscription = await query.subscribe()

    subscription.on('open', () => {
      logger.info(`WS WebSocket subscription opened on ${networkDescription} for: ${address}`)
    })

    subscription.on('update', async (object: any) => {
      this.emit('message', {
        ...object,
        network
      })
    })
  }
}
